// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IsOSo","colBig":"styles_colBig__1qQcv","colSmall":"styles_colSmall__3IdEo","shopifyNameWrapper":"styles_shopifyNameWrapper__3sydR"};